module.exports = __webpack_public_path__ + "media/images/flags/64/Olympics-cc67e3da0bd3aa64452926f86eb0a9ec.png";